import type { MarketAnalysis } from "../domain/types";
import { normalizeMarketAnalyses } from "../domain/validation";

const MARKET_ANALYSES_STORAGE_KEY = "fispro-os:market-analyses:v1";
const MARKET_ANALYSES_WIPE_KEY = "fispro-os:market-analyses-wipe:v1";

export const loadMarketAnalyses = (): MarketAnalysis[] => {
  try {
    const stored = window.localStorage.getItem(MARKET_ANALYSES_STORAGE_KEY);
    return stored ? normalizeMarketAnalyses(JSON.parse(stored)) : [];
  } catch {
    return [];
  }
};

export const saveMarketAnalyses = (analyses: MarketAnalysis[]) => {
  window.localStorage.setItem(MARKET_ANALYSES_STORAGE_KEY, JSON.stringify(analyses));
};

export const queueMarketAnalysisWipe = (createdAt = new Date().toISOString()) => {
  window.localStorage.setItem(MARKET_ANALYSES_WIPE_KEY, createdAt);
  window.localStorage.removeItem(MARKET_ANALYSES_STORAGE_KEY);
};

export const loadPendingMarketAnalysisWipe = () =>
  window.localStorage.getItem(MARKET_ANALYSES_WIPE_KEY);

export const clearPendingMarketAnalysisWipe = () => {
  window.localStorage.removeItem(MARKET_ANALYSES_WIPE_KEY);
};
